import ThumbnailEntry from "./ThumbnailEntry";

export { ThumbnailEntry as default };
